<div class="mp-header">
  <div class="mp-toolbar mp-toolbar--success" style="text-align: center;">
      <div class="mp-toolbar__content">
        <div>
          <span class="mp-label ion-text-wrap" style="font-weight: 800; font-size: 16px; padding: 7px;"
          text-wrap>{{header}}</span>
        </div>
      </div>
  </div>
</div>

<div style="margin: auto; margin-bottom: 7px; margin-top: 4px;">
  <img src="assets/icon/check.svg" width="60">
</div>

<div>
  <p style="text-align: center; font-size: 16px; padding: 2px 30px 0px 30px;">{{message}}</p>
</div>

<button class="mp-button mp-button--ios mp-button--success mp-button--block" (click)="dismiss()" style="font-weight: 900;" translate>
  <mp-icon name="checkmark-outline" style="margin-right: 4px;"></mp-icon> OK
</button>